/**
 * Route for `gamification-engine-points-levels-badges-goal-tracker-ui`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GamificationEnginePointsLevelsBadgesGoalTrackerUiPage } from "../features/gamification-engine-points-levels-badges-goal-tracker-ui/GamificationEnginePointsLevelsBadgesGoalTrackerUiPage";

export const gamificationEnginePointsLevelsBadgesGoalTrackerUiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/gamification-engine-points-levels-badges-goal-tracker-ui",
	component: GamificationEnginePointsLevelsBadgesGoalTrackerUiPage,
});

export default gamificationEnginePointsLevelsBadgesGoalTrackerUiRoute;
